import { StorageService } from './../../../services/storage/storage.service';
import { RouterService } from './../../../services/router/router.service';
import { ModalInstructionsDataConfig } from '../../../components/modal-instructions/ModalsData/ModalInformationDataConfigPublicServices';
import { LanguagesService } from './../../../services/languagesService/languages.service';
import { PayPublicServicesAutomaticService } from './../../../services/payPublicServicesAutomatic/pay-public-services-automatic.service';
import { ModalInstructionsComponent } from './../../../components/modal-instructions/modal-instructions.component';
import { Component, OnInit } from '@angular/core';
import { ICON_CATEGORY } from './iconsCategories';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { ICategoryConfig } from '../payment-services/IPayment-services.model';
import { TagsService } from 'src/app/services/tags/tags.service';
import { Config } from '@ionic/angular';

export const KEY_LAST_PROVIDER_SELECTED = 'KEY_LAST_PROVIDER_SELECTED';
@Component({
  selector: 'app-pay-public-services-automatic',
  templateUrl: './pay-public-services-automatic.page.html',
  styleUrls: ['./pay-public-services-automatic.page.scss'],
})
export class PayPublicServicesAutomaticPage implements OnInit {
  categories;
  image = '';
  ModalInformation = ModalInstructionsComponent;
  modalData = ModalInstructionsDataConfig();
  ICON_CATEGORY = ICON_CATEGORY;
  loadingCategories = false;
  loading_spinner = false;
  storeName = [];
  constructor(
    public languageService: LanguagesService,
    public router: RouterService,
    public remoteConfig: RemoteConfigService,
    private PayPublicServicesAutomaticService: PayPublicServicesAutomaticService,
    private storage: StorageService,
    private tagsService: TagsService
  ) {}

  async ngOnInit() {
    this.loadingCategories = true;
    const Config_Data = await this.remoteConfig
      .getSettingPayServicesAutomaticConfig()
      .toPromise();

    this.image =
      Config_Data.banner ||
      'https://firebasestorage.googleapis.com/v0/b/gnx-mvp-improved-stg.appspot.com/o/Default%2FPublic%20Services%2Finstructions%2FbannerServicios.png?alt=media&token=3275aa6b-7d3d-4ebc-a567-a2961085a5f8';

    this.PayPublicServicesAutomaticService.getCategories()
      .then((categories) => {
        const listCategories = categories.map((element) => {
          let category_default;
          let category: ICategoryConfig | any =
            Config_Data.category_config.find((category) => {
              return category.categoryId == element.categoryId;
            });
          if (!category) {
            category_default = Config_Data.category_config.find((category) => {
              return category.categoryId == 0;
            });
          }
          category_default = category_default
            ? category_default
            : { icon: ICON_CATEGORY.default, categoryId: 0 };
          category = category ? category : category_default;
          console.log('+++category?.img', category?.img);
          return {
            ...element,
            icon: category?.img,
          };
        });
        this.categories = [...listCategories];
      })
      .catch((err) => {
        console.error('PayPublicServicesAutomaticService error', err);
      })
      .finally(() => {
        this.loadingCategories = false;
      });
  }

  goToPayForm(category) {
    this.router.navigate(
      `app/pay-services-automatic/form/${category.categoryId}`
    );
  }

  get getTextsIUPagePaymentServices() {
    return this.languageService.textsIU.page_payment_services;
  }

  async getStoreName(event?) {
    var value = event.target.value;
    if (!value) this.storeName = [];
    // this.exhibitionForm.controls.storeName.setErrors({'incorrect': true})
    if (value.length <= 2) return;
    try {
      this.loading_spinner = true;
      const data: any =
        await this.PayPublicServicesAutomaticService.getStoreName(value, false);
      console.log('getStoreName', data);
      // this.storeName = (data.hits as Array<any>).filter((element) => element.reference1Description.length || element.reference2Description.length);
      this.storeName = data.hits as Array<any>;
      this.loading_spinner = false;
    } catch (error) {
      this.loading_spinner = false;
    }
  }

  async storeSelected(store, input) {
    this.storeName = [];
    console.log(store);
    input.value = store.agreementName;
    /*  this.f.storeName.setValue(store.agreementName);
     this.f.storeName.disable(); */
    await this.storage.set(KEY_LAST_PROVIDER_SELECTED, store);
    this.router.navigate(
      `app/pay-services-automatic/form/${store.categoryId}`,
      { queryParams: { selected_provider: true } }
    );
    input.value = '';
  }

  clear(input) {
    input.value = '';
    this.storeName = [];
    // this.f.storeName.enable();
    //this.exhibitionForm.controls.storeName.setErrors({'incorrect': true})
  }
  setTag(tag) {
    // this.tagsService.setTagFromEvent(tag);
  }
}
